import React, { useEffect, useState } from "react";
import { Cookies } from "react-cookie";
import Navbar from "../Navbar";
import {
    Autocomplete,
    Backdrop,
    Box,
    Button,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    MenuItem,
    TextField,
    Typography,
    Snackbar, Alert
} from "@mui/material";

import { Card, CardContent, CardHeader, Chip, Divider, Modal, Tooltip } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import axios from "axios";
import config from "../../config.json";

import AddIcon from "@mui/icons-material/Add";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import makeStyles from "@mui/styles/makeStyles";
import {
    DataGrid,
    GridToolbar,
    gridPageCountSelector,
    gridPageSelector,
    useGridApiContext,
    useGridSelector,
} from "@mui/x-data-grid";

import IconButton from '@mui/material/IconButton';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import CloseIcon from '@mui/icons-material/Close';

import moment from 'moment';
import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';

import { jwtDecode } from "jwt-decode";

import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { disableBackButton } from '../ConstantComponents/Constants'
import Footer from "../Footer";

const BASE_URL = config.SERVER_URL;

const TITLE = "STRAIN REPOSITORY"
const SECRET = config.SECRET;
const cookies = new Cookies();

const useStyle = makeStyles({
    root: {
        "& .MuiDataGrid-columnHeaderTitle": {
            textOverflow: "clip",
            whiteSpace: "pre-wrap",
            lineHeight: 2,
            textAlign: "center",
            fontWeight: "bold",
        },
        "& .MuiDataGrid-cellContent": {
            textOverflow: "clip",
            whiteSpace: "pre-wrap",
            lineHeight: 2,
            textAlign: "center",
            fontWeight: "bold",
        },
        "& .MuiTypography-string": {
            textOverflow: "ellipsis",
            whiteSpace: "break-spaces",
            lineHeight: 2,
            textAlign: "center",
            fontWeight: "bold",

        },
        boxShadow: 2,
        "& .MuiTablePagination-selectLabel": {
            marginTop: "auto",
        },
        "& .MuiTablePagination-displayedRows": {
            marginTop: "auto",
        },
    },
});

const inputlabelprops = {
    style: { color: '#45a2fa', fontSize: '17px' }
}

export default function EnterStrainRmrc() {

    disableBackButton()

    const navigate = useNavigate();

    const classes = useStyle();


    //const t1 = useSelector((state) => state.authToken);
    const t1 = sessionStorage.getItem("sessionid")

    //////console.log("token from redux at enter strain page", t1)
    var decodet1 = ""

    try {
        decodet1 = jwtDecode(t1)
    } catch (error) {

    }

    const name = decodet1.fname + " " + decodet1.lname
    const role = decodet1.role


    const [backdropopen, setbackdropopen] = useState(true);
    const [surveyType, setsurveyType] = useState([]);
    const [centers, setcenters] = useState([]);
    const [getIdentified, setgetIdentified] = useState([]);

    const [rmrcstrains, setrmrcstrains] = useState([]);

    const [virulencegenearr, setvirulencegenearr] = useState("");

    const [surveyid, setsurveyid] = useState("");
    const [errsurveyb, seterrsurveyb] = useState(false);
    const [errsurvey, seterrsurvey] = useState("");

    const [centerid, setcenterid] = useState("");
    const [errcenteridb, seterrcenteridb] = useState(false);
    const [errcenterid, seterrcenterid] = useState("");

    const [selectedSample, setSelectedSample] = useState(null);

    const [sampleid, setsampleid] = useState("");

    const [strainid, setstrainid] = useState("");
    const [errstrainidb, seterrstrainidb] = useState(false);
    const [errstrainid, seterrstrainid] = useState("");

    const [samplecategory, setsamplecategory] = useState("");
    const [samplecategoryid, setsamplecategoryid] = useState("");
    const [samplesubcategory, setsamplesubcategory] = useState("");
    const [samplesubcategoryid, setsamplesubcategoryid] = useState("");
    const [samplesupercategory, setsamplesupercategory] = useState("");
    const [samplesupercategoryid, setsamplesupercategoryid] = useState("");
    const [virulencegene, setvirulencegene] = useState("");
    const [sensitive, setsensitive] = useState("");
    const [intermediate, setintermediate] = useState("");
    const [resistant, setresistant] = useState("");

    const [stateid, setstateid] = useState()
    const [districtid, setdistrictid] = useState()

    const [pathidentified, setpathidentified] = useState("");
    const [serotype, setserotype] = useState("");

    const [sequenceno, setsequenceno] = useState("");

    const [testcategory, settestcategory] = useState("");
    const [testsubcategory, settestsubcategory] = useState("");
    const [testproperty, settestproperty] = useState("");
    const [testdate, settestdate] = useState("");

    const [strainprefix, setstrainprefix] = useState("FBP/RMRC/");

    const [loading, setloading] = useState(true);
    const [pageSize, setPageSize] = useState(10);

    const [refresh, setrefresh] = useState('0')

    const [divdisplay, setdivdisplay] = useState('none')

    const [snackopen, setsnackopen] = useState(false)
    const [snackmessage, setsnackmessage] = useState('')
    const [snacklevel, setsnacklevel] = useState('success')


    //modal view variables

    const [centernameview, setcenternameview] = useState('')
    const [testsubcategorynameview, settestsubcategorynameview] = useState('')
    const [testpropertyview, settestpropertyview] = useState('')
    const [serotypeview, setserotypeview] = useState('')
    const [samplecategoryview, setsamplecategoryview] = useState('')
    const [samplesubcategoryview, setsamplesubcategoryview] = useState('')
    const [antibiogramview, setantibiogramview] = useState('')
    const [antiresistantview, setantiresistantview] = useState('')
    const [antiintermediateview, setantiintermediateview] = useState('')
    const [virulenceview, setvirulenceview] = useState('')
    const [nicedstrainidview, setnicedstrainidview] = useState('')
    const [updateddateview, setupdateddateview] = useState('')
    const [syssampleidview, setsyssampleidview] = useState('')
    const [icmrsampleid, seticmrsampleid] = useState('')
    const [surveynameview, setsurveynameview] = useState('')
    const [supercategorynameview, setsupercategorynameview] = useState('')
    const [viewformModal, setviewformModal] = useState(false)


    const [dialogopen, setdialogopen] = useState(false)
    const [dialogtitle, setdialogtitle] = useState("")
    const [dialogcontent, setdialogcontent] = useState("")

    const style2 = {
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: 'auto',
        maxHeight: '100vh',
        transform: 'translate(-50%, -50%)',
        overflowY: 'auto',
        margin: 'auto'


    }

    useEffect(() => {

        setbackdropopen(true)
        if (decodet1 === "") {
            navigate("/")
        } else {
            getPrerequisits()

        }
    }, [refresh])


    function getPrerequisits() {
        const getSurveyType = axios.post(BASE_URL + "/master/getSurveyType",
            {},
            { withCredentials: true }
            //{ headers:  headers}
        );

        const getCenters = axios.post(BASE_URL + "/master/getCenters",
            {},
            { withCredentials: true }
            //{ headers:  headers}
        );

        const getLatestCount = axios.post(BASE_URL + "/strainrmrc/getLatestCountRmrc",
            {},
            { withCredentials: true }
            //{ headers:  headers}
        );

        const getStrainsRmrc = axios.post(BASE_URL + "/strainrmrc/viewStrainRmrc",
            {},
            { withCredentials: true }
            //{ headers:  headers}
        );


        Promise.all([getSurveyType, getCenters, getLatestCount, getStrainsRmrc])
            .then(function (responses) {
                setsurveyType(responses[0].data.SurveyType);
                setcenters(responses[1].data.Centers);

                setstrainid(responses[2].data.Count)
                setrmrcstrains(responses[3].data.StrainsRmrc);
                setloading(false);

                setrefresh("0")
                //////console.log(responses[2].data.Strains);

                ////////console.log("surveytype: ", responses[0].data.SurveyType)
                setbackdropopen(false)
            })
            .catch(function (errors) {
                //////console.log("survey errors", errors[0]);
                //////console.log("center errors", errors[1]);
            });
    }



    const columns = [
        {
            field: "sysStrainId",
            headerName: "SL",
            flex: 0.5, align: 'center', headerAlign: 'center',
        },
        {
            field: "icmrStrainId",
            headerName: "RMRC STRAIN ID",
            flex: 1.5, align: 'center', headerAlign: 'center'
        },
        {
            field: "surveyName",
            headerName: "Survey Type",
            flex: 1, align: 'center', headerAlign: 'center'
        }
        ,
        // {
        //     field: "centerName",
        //     headerName: "Center",
        //     flex: 2, align: 'center', headerAlign: 'center'
        // },
        {
            field: "pathogen",
            headerName: "Pathogen Identified",
            flex: 1.5, align: 'center', headerAlign: 'center',
            renderCell: (params) => {
                return (<> <Typography variant="string" style={{ fontStyle: 'italic' }} >
                    {params.row.subcategoryName} &nbsp;
                </Typography>
                    <Typography variant="string" style={{ fontStyle: 'italic' }} >
                        {(params.row.propertyName === "Positive" || params.row.propertyName === "Unknown") ? "" : `(${params.row.propertyName})`}
                    </Typography>
                </>)
            }
        },
        // ,
        // {
        //     field: "serotype",
        //     headerName: "Serotype",
        //     flex: 1, align: 'center', headerAlign: 'center',
        //     renderCell: (params) => {
        //         return (<> <Typography variant="string"  >
        //             {params.row.serotype ? params.row.serotype : "Not Available"} &nbsp;
        //         </Typography>
        //         </>)
        //     }
        // },
        {
            field: "updatedDate",
            headerName: "Added On",
            flex: 1, align: 'center', headerAlign: 'center',
            renderCell: (params) => {
                return (<Typography variant="string" >
                    {moment(params.row.updatedDate).format('LL')}
                </Typography>)
            }
        },
        {
            field: "View",
            renderCell: (cellValues) => {
                return (
                    <IconButton
                        //   variant="contained"
                        //   color="primary"
                        //   size='medium'
                        //   startIcon={<EditIcon></EditIcon>}

                        onClick={(event) => {
                            //handleViewOpen(event, cellValues);
                            handleviewformModal(event, cellValues);
                        }}
                    >
                        <DesktopWindowsOutlinedIcon></DesktopWindowsOutlinedIcon>
                    </IconButton>
                );
            }, flex: 0.5, align: 'center', headerAlign: 'center'
        }
    ];


    const handleviewformModal = (event, cellValues) => {
        setviewformModal(true)

        setcenternameview(cellValues.row.centerName)
        settestsubcategorynameview(cellValues.row.subcategoryName)
        setsamplecategoryview(cellValues.row.sampleCategoryName)
        setsamplesubcategoryview(cellValues.row.sampleSubcategoryName)
        setantibiogramview(cellValues.row.antibioticSensitive)
        setvirulenceview(cellValues.row.virulenceGene)
        setnicedstrainidview(cellValues.row.icmrStrainId)
        setupdateddateview(cellValues.row.updatedDate)
        setsyssampleidview()
        setsurveynameview(cellValues.row.surveyName)
        setsupercategorynameview(cellValues.row.superCategoryName)
        settestpropertyview(cellValues.row.propertyName)
        setserotypeview(cellValues.row.serotype)
        setantiintermediateview(cellValues.row.antibioticIntermediate)
        setantiresistantview(cellValues.row.antibioticResistant)
    }

    const handleviewformModalClose = () => {
        setviewformModal(false)
    }

    const changeinsurvey = (value) => {

        setsurveyid(value)

        setcenterid("")

        setsamplecategory("");
        setsamplesubcategory("");
        setsamplesupercategory("");
        setpathidentified("");
        setserotype("");
        setvirulencegene("");
        setsensitive("");
        setresistant("");
        setintermediate("");
        setSelectedSample(null)

    }

    const changeInCenter = (value) => {

        setbackdropopen(true)
        setcenterid(value)

        const centerparam = new URLSearchParams();
        centerparam.append("center_id", value);
        centerparam.append("survey_id", surveyid);

        const getIdentifiedPath = axios.post(BASE_URL + "/strainrmrc/getIdentifiedPathogensRmrc",
            centerparam,
            { withCredentials: true }
            //{ headers:  headers}
        );

        Promise.all([getIdentifiedPath])
            .then(function (responses) {
                if (responses[0].data.Identified.length == 0) {
                    setbackdropopen(false)
                    setgetIdentified([])
                    setsnackmessage("No Samples Found")
                    setsnacklevel("error")
                    setsnackopen(true)
                } else {
                    ////console.log("rmrc path", responses[0].data)
                    setgetIdentified(responses[0].data.Identified);
                    setbackdropopen(false)



                    setSelectedSample(null);
                    setSelectedSample(null);
                    setsamplecategory("");
                    setsamplesubcategory("");
                    setsamplesupercategory("");
                    setpathidentified("");
                    setserotype("");
                    setvirulencegene("");
                    setsensitive("");
                    setresistant("");
                    setintermediate("");
                }
            })
            .catch(function (error) {

                ////console.log("in get path error")
                setbackdropopen(false);

                setSelectedSample(null);
                setgetIdentified([])
                setsamplecategory("");
                setsamplesubcategory("");
                setsamplesupercategory("");
                setpathidentified("");
                setserotype("");
                setvirulencegene("");
                setsensitive("");
                setresistant("");
                setintermediate("");
                setsnackmessage("Something Went Wrong")
                setsnacklevel("error")
                setsnackopen(true)
            })

    }

    const handleSampleChange = (event, newValue) => {

        setbackdropopen(true)

        if (newValue !== null) {




            setSelectedSample(newValue);
            //////console.log("value", newValue.sysSampleId);

            setsampleid(newValue.sysSampleId);

            setsamplecategory(newValue.sampleCategoryName);
            setsamplecategoryid(newValue.sampleCategoryId);

            setsamplesubcategory(newValue.sampleSubcategoryName);
            setsamplesubcategoryid(newValue.sampleSubcategoryId);

            setsamplesupercategory(newValue.superCategoryName);
            setsamplesupercategoryid(newValue.supercategoryId);

            setsequenceno(newValue.sequenceNo);

            settestcategory(newValue.categoryId);
            settestsubcategory(newValue.subcategoryId);
            settestproperty(newValue.propertyId);
            settestdate(newValue.testDate);

            setstateid(newValue.stateId)
            setdistrictid(newValue.districtId)

            let newPrefix = "FBP/RMRC/" + moment(newValue.testDate).format("YYYY") + "/"

            setstrainprefix(newPrefix)

            const patho =
                newValue.subcategoryName + " (" + newValue.propertyName + ")";

            setpathidentified(patho);

            setserotype("Not Available")

            const sampleparam = new URLSearchParams();
            sampleparam.append("sys_sample_id", newValue.sysSampleId);
            sampleparam.append("survey_id", surveyid)
            sampleparam.append("center_id", centerid)

            const getVirulenceAnti = axios.post(BASE_URL + "/strainrmrc/getAntiVirulenceRmrc",
                sampleparam,
                { withCredentials: true }
                //{ headers:  headers}
            );

            Promise.all([getVirulenceAnti])
                .then(function (responses) {
                    ////console.log("antivir", responses[0].data)

                    // if (responses[0].data.Antibiotic.length === 0 && responses[0].data.Virulence.length === 0) {
                    //     setbackdropopen(false);
                    //     setdialogtitle("Data Not Found")
                    //     setdialogcontent("AST Details or Virulence Gene not found for Selected Sample")
                    //     setdialogopen(true)
                    //     setdivdisplay("none")
                    // }
                    // else {
                    //     if (responses[0].data.Virulence.length === 0) {
                    //         setvirulencegene("Not Available");

                    //     } else {
                    //         setvirulencegene(
                    //             responses[0].data.Virulence.map((item) => item.propertyName).join(
                    //                 ", "
                    //             )
                    //         );
                    //     }

                    //     if (responses[0].data.Antibiotic.filter(
                    //         (item) => item.propertyName === "Sensitive"
                    //     ).length === 0) {
                    //         setsensitive("Not Available")
                    //     } else {
                    //         setsensitive(responses[0].data.Antibiotic.filter(
                    //             (item) => item.propertyName === "Sensitive"
                    //         )
                    //             .map((item) => item.testSubcategoryName)
                    //             .join(", "))
                    //     }


                    //     if (responses[0].data.Antibiotic.filter(
                    //         (item) => item.propertyName === "Intermediate"
                    //     ).length === 0) {
                    //         setintermediate("Not Available")
                    //     } else {
                    //         setintermediate(
                    //             responses[0].data.Antibiotic.filter(
                    //                 (item) => item.propertyName === "Intermediate"
                    //             )
                    //                 .map((item) => item.testSubcategoryName)
                    //                 .join(", ")
                    //         );

                    //     }

                    //     if (responses[0].data.Antibiotic.filter(
                    //         (item) => item.propertyName === "Resistant"
                    //     ).length === 0) {
                    //         setresistant("Not Available")
                    //     } else {
                    //         setresistant(
                    //             responses[0].data.Antibiotic.filter(
                    //                 (item) => item.propertyName === "Resistant"
                    //             )
                    //                 .map((item) => item.testSubcategoryName)
                    //                 .join(", ")
                    //         );
                    //     }

                    //     setbackdropopen(false);

                    //     setdivdisplay("block")
                    // }

                    if (responses[0].data.Virulence.length === 0) {
                        setvirulencegene("Not Available");

                    } else {
                        setvirulencegene(
                            responses[0].data.Virulence.map((item) => item.propertyName).join(
                                ", "
                            )
                        );
                    }

                    if (responses[0].data.Antibiotic.filter(
                        (item) => item.propertyName === "Sensitive"
                    ).length === 0) {
                        setsensitive("Not Available")
                    } else {
                        setsensitive(responses[0].data.Antibiotic.filter(
                            (item) => item.propertyName === "Sensitive"
                        )
                            .map((item) => item.testSubcategoryName)
                            .join(", "))
                    }


                    if (responses[0].data.Antibiotic.filter(
                        (item) => item.propertyName === "Intermediate"
                    ).length === 0) {
                        setintermediate("Not Available")
                    } else {
                        setintermediate(
                            responses[0].data.Antibiotic.filter(
                                (item) => item.propertyName === "Intermediate"
                            )
                                .map((item) => item.testSubcategoryName)
                                .join(", ")
                        );

                    }

                    if (responses[0].data.Antibiotic.filter(
                        (item) => item.propertyName === "Resistant"
                    ).length === 0) {
                        setresistant("Not Available")
                    } else {
                        setresistant(
                            responses[0].data.Antibiotic.filter(
                                (item) => item.propertyName === "Resistant"
                            )
                                .map((item) => item.testSubcategoryName)
                                .join(", ")
                        );
                    }

                    setbackdropopen(false);

                    setdivdisplay("block")

                })
                .catch(function (errors) {
                    setbackdropopen(false);
                })



        } else {
            setSelectedSample(null); // Clear the selected sample
            setsamplecategory("");
            setsamplesubcategory("");
            setsamplesupercategory("");
            setpathidentified("")
            setserotype("")
            setvirulencegene("")
            setresistant("")
            setintermediate("")
            setsensitive("")
            setbackdropopen(false);

        }
    }

    const handleDialogClose = () => {
        setdialogopen(false)
        setSelectedSample(null); // Clear the selected sample
        setsamplecategory("");
        setsamplesubcategory("");
        setsamplesupercategory("");
        setpathidentified("")
        setserotype("")
        setvirulencegene("")
        setresistant("")
        setintermediate("")
        setsensitive("")
        setdivdisplay("none")
    }


    const handleAddStrainClick = () => {

        setbackdropopen(true)

        const strainData = {
            seqNo: strainid,
            icmrStrainId: strainprefix + strainid,
            surveyId: surveyid,
            centerId: centerid,
            sysSampleId: sampleid,
            supercategoryId: samplesupercategoryid,
            sampleCategoryId: samplecategoryid,
            sampleSubcategoryId: samplesubcategoryid,
            sequenceNo: sequenceno,
            testCategoryId: testcategory,
            testSubcategoryId: testsubcategory,
            testPropertyId: testproperty,
            serotype: serotype,
            testDate: testdate,
            antibioticSensitive: sensitive,
            antibioticIntermediate: intermediate,
            antibioticResistant: resistant,
            virulenceGene: virulencegene,
            stateId: stateid,
            districtId: districtid
        };

        //console.log("rmrcstrain", strainData)

        axios
            .post(BASE_URL + "/strainrmrc/addStrainRmrc", strainData, {
                withCredentials: true,
            })
            .then((response) => {
                //////console.log("resp: ", response);

                if (response.status == 200 && response.data.status === "ok") {


                    setsnackmessage(response.data.message)
                    setsnacklevel("success")
                    setsnackopen(true)
                    setrefresh("1")
                    clearFields()
                    setdivdisplay("none")
                } else if (response.status == 200 && response.data.status === "failed") {

                    setsnackmessage(response.data.message)
                    setsnacklevel("error")
                    setsnackopen(true)
                }

                setbackdropopen(false);
            })
            .catch((error) => {


                setsnackmessage("Something went wrong")
                setsnacklevel("error")
                setsnackopen(true)
                //////console.log("login error", error[0]);
                setbackdropopen(false);
            });



    }





    const handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setsnackopen(false)
    }

    function clearFields() {

        setsurveyid("")
        setcenterid("")
        setsampleid("")
        setstrainid("")
        setsamplecategory("")
        setsamplecategoryid("")
        setsamplesubcategory("")
        setsamplesubcategoryid("")
        setsamplesupercategory("")
        setsamplesupercategoryid("")
        setvirulencegene("")
        setsensitive("")
        setintermediate("")
        setresistant("")
        setserotype("")
        setsequenceno("")
        settestcategory("")
        settestsubcategory("")
        settestproperty("")
        settestdate("")

        setSelectedSample(null); // Clear the selected sample
        setsamplecategory("");
        setsamplesubcategory("");
        setsamplesupercategory("");
        setpathidentified("")
        setserotype("")
        setvirulencegene("")
        setresistant("")
        setintermediate("")
        setsensitive("")

    }




    return (
        <>
            <Navbar
                title={TITLE}
                name={name}
                role={role}
            ></Navbar>
            <div className="container" style={{ marginTop: 20, marginBottom: 20 }}>
                <h1>
                    <div className="text-black text-center col 10 p-1 mt-2">
                        <h2
                            className="rubik-font"
                            style={{ color: "black", fontWeight: "lighter" }}
                        >
                            {" "}
                            Add New Strain (RMRC){" "}
                        </h2>
                    </div>
                </h1>
            </div>
            <div className="container">

                <Box

                    sx={{
                        marginTop: 4,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "1px solid",
                        padding: "20px",
                        borderRadius: "20px",
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6} lg={4}>
                            <div>
                                <TextField
                                    error={errsurveyb}
                                    helperText={errsurvey}
                                    required
                                    fullWidth
                                    id="outlined-select-district"
                                    select
                                    label="Select Surveillance Type"
                                    value={surveyid}
                                    onChange={
                                        (e) => changeinsurvey(e.target.value)
                                        //setdistrict(centers.filter(op => op.center_dist_id === district))
                                    }
                                    InputLabelProps={inputlabelprops}


                                // InputProps={{
                                //   readOnly: true,
                                // }}
                                //onChange={handleChange}
                                >
                                    {surveyType.map((option) => (
                                        <MenuItem key={option.surveyId} value={option.surveyId}>
                                            {option.survey_name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <div>
                                <TextField
                                    error={errcenteridb}
                                    helperText={errcenterid}
                                    required
                                    fullWidth
                                    id="outlined-select-district"
                                    select
                                    label="Select Center"
                                    value={centerid}
                                    onChange={
                                        (e) => changeInCenter(e.target.value)
                                        //setdistrict(centers.filter(op => op.center_dist_id === district))
                                    }
                                    InputLabelProps={inputlabelprops}
                                >
                                    {centers.map((option) => (
                                        <MenuItem key={option.centerId} value={option.centerId}>
                                            {option.centerName}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <div>
                                <Autocomplete
                                    value={selectedSample}
                                    onChange={handleSampleChange}
                                    options={getIdentified}

                                    getOptionLabel={(option) => option.icmrSampleId}
                                    renderInput={(params) => (
                                        <TextField {...params} required label="Select Sample" InputLabelProps={inputlabelprops} />
                                    )}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            <div>{option.icmrSampleId}</div>
                                        </li>
                                    )}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Box>

            </div>


            <div style={{ display: divdisplay, transition: 'transform 0.5s ease-in-out' }}>
                <Box

                    sx={{
                        marginTop: 5,
                        marginLeft: 15,
                        marginRight: 15,
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: 'wrap',
                        justifyContent: 'space-evenly',
                        border: "1px solid",
                        borderRadius: "20px",
                    }}
                >


                    <Box sx={{
                        margin: 1, width: '450px', padding: '15px'
                    }}>
                        <div
                            className="container"
                            style={{ textAlign: "center", marginBottom: "25px", }}
                        >
                            <h4
                                className="rubik-font"
                                style={{
                                    color: "black",
                                    fontWeight: "lighter",
                                    textAlign: "center",
                                }}
                            >

                                Sample Details
                            </h4>
                        </div>
                        <Grid item xs={12} md={12} lg={12}>
                            <div>
                                <TextField

                                    fullWidth
                                    label="Sample Super Category"
                                    value={samplesupercategory}
                                    InputProps={{
                                        readOnly: true,
                                    }}

                                    InputLabelProps={inputlabelprops}

                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12} sx={{ marginTop: 5 }}>
                            <div>
                                <TextField

                                    fullWidth
                                    label="Sample Category"
                                    value={samplecategory}
                                    InputProps={{
                                        readOnly: true,
                                    }}

                                    InputLabelProps={inputlabelprops}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12} sx={{ marginTop: 5 }}>
                            <div>
                                <TextField
                                    fullWidth
                                    label="Sample SubCategory"
                                    value={samplesubcategory}
                                    InputProps={{
                                        readOnly: true,
                                    }}

                                    InputLabelProps={inputlabelprops}
                                />
                            </div>
                        </Grid>
                    </Box>


                    <Box sx={{
                        margin: 1, width: '450px', padding: '15px'
                    }}>
                        <div
                            className="container"
                            style={{ textAlign: "center", marginBottom: "25px" }}
                        >
                            <h4
                                className="rubik-font"
                                style={{
                                    color: "black",
                                    fontWeight: "lighter",
                                    textAlign: "center",
                                }}
                            >
                                {" "}
                                Pathogen and Virulence Genes
                            </h4>
                        </div>
                        <Grid item xs={12} md={12} lg={12}>
                            <div>
                                <TextField
                                    fullWidth
                                    label="Pathogen Identified"

                                    value={pathidentified}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={inputlabelprops}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12} sx={{ marginTop: 5 }}>
                            <div>
                                <TextField
                                    fullWidth
                                    label="Serotype"
                                    value={serotype}
                                    InputProps={{
                                        readOnly: true,
                                    }}

                                    InputLabelProps={inputlabelprops}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12} sx={{ marginTop: 5 }}>
                            <div>
                                <TextField
                                    fullWidth
                                    label="Virulence Genes"
                                    value={virulencegene}
                                    multiline
                                    InputProps={{
                                        readOnly: true,
                                    }}

                                    InputLabelProps={inputlabelprops}
                                />
                            </div>
                        </Grid>
                    </Box>


                    <Box sx={{
                        margin: 1, width: '450px', padding: '15px'
                    }}>
                        <div
                            className="container"
                            style={{ textAlign: "center", marginBottom: "25px" }}
                        >
                            <h4
                                className="rubik-font"
                                style={{
                                    color: "black",
                                    fontWeight: "lighter",
                                    textAlign: "center",
                                }}
                            >
                                {" "}
                                Antibiotic Details
                            </h4>
                        </div>
                        <Grid item xs={12} md={12} lg={12}>
                            <div>
                                <TextField
                                    fullWidth
                                    label="Antibiotic Sensitive"
                                    value={sensitive}
                                    multiline
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={inputlabelprops}

                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12} sx={{ marginTop: 5 }}>
                            <div>
                                <TextField
                                    fullWidth
                                    label="Antibiotic Intermediate"
                                    value={intermediate}
                                    multiline
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={inputlabelprops}

                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12} sx={{ marginTop: 5 }}>
                            <div>
                                <TextField
                                    fullWidth
                                    label="Antibiotic Resistant"
                                    value={resistant}
                                    multiline
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={inputlabelprops}

                                />
                            </div>
                        </Grid>
                    </Box>



                </Box>
            </div>


            <div style={{ display: divdisplay, transition: 'transform 0.5s ease-in-out' }}>
                <div className="container" >
                    <Box

                        sx={{
                            marginTop: 4,
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid",
                            padding: "20px",
                            borderRadius: "20px",
                            flexWrap: "wrap",
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div style={{ margin: 5 }}>
                            <TextField
                                fullWidth
                                label="Strain Prefix"
                                value={strainprefix}
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={inputlabelprops}

                            ></TextField>
                        </div>
                        <div style={{ margin: 5 }}>
                            <TextField
                                fullWidth
                                error={errstrainidb}
                                helperText={errstrainid}
                                required
                                label="ID"
                                value={strainid}
                                onChange={
                                    (e) => setstrainid(e.target.value)
                                    //setdistrict(centers.filter(op => op.center_dist_id === district))
                                }
                                InputLabelProps={inputlabelprops}
                            // InputProps={{
                            //   readOnly: true,
                            // }}
                            ></TextField>
                        </div>
                        <Button
                            variant="contained"
                            onClick={handleAddStrainClick}
                            startIcon={<AddIcon />}
                            sx={{ backgroundColor: '#45a2fa' }}
                        >
                            Add Strain
                        </Button>
                    </Box>
                </div>
            </div>


            <div className="row mx-5 mb-5 mt-5" >
                <div className="container" style={{ marginBottom: 200 }}>
                    <h2 className="rubik-font" style={{ textAlign: 'center', marginBottom: 50, color: "black", fontWeight: "lighter" }}>Added Strains</h2>
                    <Box sx={{ height: 500, justifyContent: "center" }}>
                        <DataGrid
                            className={classes.root}
                            sx={{
                                boxShadow: 2,
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "auto",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "auto",
                                },
                                "& .MuiDataGrid-cell": {
                                    padding: 0.5,
                                },
                                overflowX: "hidden",
                                borderRadius: 4,
                                padding: 2,
                                border: "1px solid"
                            }}
                            rows={rmrcstrains}
                            getRowId={(r) => r.sysStrainId}
                            columns={columns}
                            components={{ Toolbar: GridToolbar }}
                            loading={loading}
                            pageSize={pageSize}
                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                            pagination
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            disableVirtualization
                            disableSelectionOnClick={true}
                            rowHeight={50}
                            disableRowSelectionOnClick
                            autoHeight
                        />
                    </Box>
                </div>
            </div>
            <Footer />


            {/**dialog box */}
            <Dialog
                open={dialogopen}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {dialogtitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {dialogcontent}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>Close</Button>

                </DialogActions>
            </Dialog>



            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={backdropopen}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackopen} autoHideDuration={6000} onClose={handleSnackClose}>
                <Alert

                    onClose={handleSnackClose}
                    severity={snacklevel}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {snackmessage}
                </Alert>
            </Snackbar>

            {/**view modal */}
            <Modal
                open={viewformModal}
                onClose={handleviewformModalClose}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box sx={style2}>
                    <div style={{ alignItems: 'end', justifyItems: 'end', display: 'grid', marginBottom: '-40px' }}>
                        <Tooltip title='Close'>
                            <IconButton
                                sx={{
                                    color: 'rgb(255, 255, 255)'
                                }}
                                onClick={(event) => {
                                    handleviewformModalClose(event)


                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Tooltip>
                    </div>

                    <Card sx={{ width: '100%', height: 'auto', alignItems: 'center', boxShadow: 10, borderRadius: 3, display: 'grid', backgroundColor: "#f5f5f5" }}>
                        <CardHeader
                            title={'Strain ID: ' + ' ' + nicedstrainidview}
                            //subheader={'ICMR Sample ID: ' + ' ' + icmrsampleid}
                            style={{ textAlign: 'left' }}
                            titleTypographyProps={{ variant: 'h5', fontWeight: 'bold', color: 'white' }}
                            subheaderTypographyProps={{ variant: 'h6', fontWeight: 'bold', color: 'white' }}
                            sx={{ justifyContent: 'center', display: 'grid', background: '#45a2fa' }}

                        >
                        </CardHeader>
                        {/* <Divider sx={{ bgcolor: "secondary.light" }} orientation="horizontal" flexItem /> */}
                        <Divider style={{ width: '500%', background: 'black' }} >

                        </Divider>


                        <CardContent>

                            <TableContainer component={Paper}>
                                <Table sx={{ width: 'auto', height: 'auto', border: '2px solid' }} aria-label="customized table">
                                    <TableBody sx={{ border: '2px solid' }}>
                                        <TableRow >
                                            <TableCell sx={{ border: '1px solid', color: 'black' }} align="right">Identified Pathogen</TableCell>
                                            <TableCell align="left" sx={{ fontStyle: 'italic', fontWeight: 'bold', border: '1px solid' }}>{testsubcategorynameview}</TableCell>
                                            <TableCell sx={{ border: '1px solid', color: 'black' }} align="right">Serotype</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: 'bold', border: '1px solid' }}>{serotypeview ? serotypeview : "Not Available"}</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ background: '#ced6d6' }}>
                                            <TableCell sx={{ border: '1px solid' }} align="right">SuperCategory</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: 'bold', border: '1px solid' }}>{supercategorynameview}</TableCell>
                                            <TableCell align="right" sx={{ border: '1px solid' }}> Category</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: 'bold', border: '1px solid' }}>{samplecategoryview}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="right" sx={{ border: '1px solid' }}>Sub Category</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: 'bold', border: '1px solid' }}>{samplesubcategoryview}</TableCell>
                                            <TableCell align="right" sx={{ border: '1px solid' }}>Survey Name</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: 'bold', border: '1px solid' }}>{surveynameview}</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ background: '#ced6d6' }}>
                                            <TableCell align="right" sx={{ border: '1px solid' }}>Center Name</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: 'bold', border: '1px solid' }}>{centernameview}</TableCell>
                                            <TableCell align="right" sx={{ border: '1px solid' }}>Upload Date</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: 'bold', border: '1px solid' }}>{moment(updateddateview).format("LL")}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="right" sx={{ border: '1px solid' }}>Antibiotic Sensitive</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: 'bold', border: '1px solid' }}>{antibiogramview === "" ? "Not Available" : antibiogramview}</TableCell>
                                            <TableCell align="right" sx={{ border: '1px solid' }}>Antibiotic Intermediate</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: 'bold', border: '1px solid' }}>{antiintermediateview === "" ? "Not Available" : antiintermediateview}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="right" sx={{ border: '1px solid' }}>Antibiotic Resistant</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: 'bold', border: '1px solid' }}>{antiresistantview === "" ? "Not Available" : antiresistantview}</TableCell>
                                            <TableCell align="right" sx={{ border: '1px solid' }}>Virulence Genes</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: 'bold', border: '1px solid' }}>{virulenceview === "" ? "Not Available" : virulenceview}</TableCell>
                                        </TableRow>

                                    </TableBody>
                                </Table>
                            </TableContainer>


                        </CardContent>



                    </Card>


                </Box>
            </Modal>


        </>
    )
}
